module.exports = __webpack_public_path__ + "static/media/bg.88625929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/imgs/bg.jpg
// module id = 2306
// module chunks = 0